export default __webpack_public_path__ + "static/media/a1-3-0.f06ca2ef.jpg";